import React from "react";
import moment from "moment";
import { TAnnex6V2Record } from "redux/app/annex6-v2/@types";
import { TAnnex6V2GroupH1 } from "redux/app/annex6-v2/groups/group-h";
import Annex6V2TableRows from "../Annex6V2TableRows";

type OwnProps = {
	annex6V2Record: TAnnex6V2Record;
	isStrikedOff?: boolean;
	theme?: "light" | "dark";
};
type Annex6V2GroupH1PreviewProps = OwnProps;

function Annex6V2GroupH1Preview(props: Annex6V2GroupH1PreviewProps) {
	const record = props.annex6V2Record as TAnnex6V2GroupH1;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);
	const { itemH1P2 } = record;

	function renderMain() {
		const tableRows = [
			[operationDate, "H", "1", renderItemP1()],
			[null, null, "2", renderItemP2()],
		];

		if (record.remarks) {
			tableRows.push([null, null, "NOTE", record.remarks]);
		}

		return (
			<Annex6V2TableRows
				record={record}
				tableRows={tableRows}
				theme={props.theme}
			/>
		);
	}

	function renderItemP1() {
		const { date: smtDate, time: smtTime } = record.itemH1P1.receipt;
		const dateTimeLocal = `${smtDate}T${smtTime}:00${record.timeZone}`;
		const utcTime = moment.utc(dateTimeLocal);

		return (
			<h4 className="font-medium uppercase">
				Bunkering operation carried out on {utcTime.format("HH:mm")} hrs UTC on{" "}
				{utcTime.format("DD-MMM-YYYY")} ({smtTime} SMT on{" "}
				{moment(smtDate, "YYYY-MM-DD").format("DD-MMM-YYYY")})
			</h4>
		);
	}

	function renderItemP2() {
		const { details, bdn } = itemH1P2;
		return (
			<h4 className="font-medium uppercase">
				BDN reference number: {bdn}
				{details && <div>{details}</div>}
			</h4>
		);
	}

	return renderMain();
}

export default Annex6V2GroupH1Preview;
